import React, { useCallback, useEffect, useState } from "react";
import Modal from "react-responsive-modal";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import axios from "axios";
import { toast } from "react-toastify";
import { Api, BaseUrl } from "../../Config/Api";
import { getAssetsData } from "../../../redux/actions/adminAction";
import { getAssingAssetsData } from "../../../redux/actions/employeeActions";

const AssetAssign = ({ open, onClose, assetsData }) => {
  const userDetails = JSON.parse(sessionStorage.getItem("userDetails")) || {};
  const employeeId = sessionStorage.getItem("employeeId");
  const setLoading = () => { };
  const logout = () => { };
  const dispatch = useDispatch();
  const token = sessionStorage.getItem("authToken");
  const [selectedImages, setSelectedImages] = useState([]);
  const getEmployeeDetails = useSelector((state) => state?.adminData?.employeeListData);
  const profileData = useSelector((state) => state.employeeData?.profile)
  // //console.log("getEmployeeDetails" ,getEmployeeDetails);

  const initialFormData = {
    description1: "",
    assigned_date: "",
    status: "Active",
    image: "",
  };
  const [formData, setFormData] = useState({
    description1: "",
    assigned_date: "",
    status: "Active",
    image: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevFormData) => ({
      ...prevFormData,
      [name]: value,
    }));
  };
  const handleImageChange = (e) => {
    const files = Array.from(e.target.files);
    setSelectedImages(files);
  };



  const handleSubmit = async (e) => {
    e.preventDefault();

    if (selectedImages == null) {
      toast.error("Please select image");
    } else {
      setLoading(true);
      try {
        const formDataToSend = new FormData();

        selectedImages?.forEach((image) => {
          formDataToSend?.append("image[]", image);
        });
        formDataToSend.append("employee_id", formData?.name);
        formDataToSend.append("assigned_date", formData?.assigned_date);
        formDataToSend.append("description", formData?.description1);
        formDataToSend.append("status", formData?.status);
        formDataToSend.append("itemname", assetsData?.itemname);
        formDataToSend.append("categories", assetsData?.category);
        formDataToSend.append("model_number", assetsData?.model_number);
        formDataToSend.append("model", assetsData?.model_brand);
        formDataToSend.append("serial_number", assetsData?.serial_number);
        formDataToSend.append("assigned_by", employeeId);
        formDataToSend.append("item_remark", assetsData?.description);

        const response = await axios.post(
          `${BaseUrl}${Api.ASSIGN_ASSETS}`,
          formDataToSend,
          {
            headers: {
              "Content-Type": "multipart/form-data",
              Authorization: `Bearer ${token}`,
              "X-Company-ID": userDetails.company_id,
            },
          }
        );

        if (response?.data?.authenticated === false) {
          toast.error(response?.data?.mssg[0]);
          logout();
          setLoading(false);
        } else {
          if (response?.data?.valid === false) {
            setLoading(false);
            toast.error(response?.data?.mssg[0]);
          } else {
            toast.success(response?.data?.mssg);
            setLoading(false);
            dispatch(getAssetsData());
            dispatch(getAssingAssetsData());
            setFormData(initialFormData);
            setSelectedImages([]);
            onClose()
          }
        }
      } catch (error) {
        console.error("API call failed:", error);
        alert("An error occurred. Please try again.");
        setLoading(false);
      } finally {
        setLoading(true);
      }
    }
  };


  return (
    <Modal
      open={open}
      onClose={onClose}
      center
      showCloseIcon={false}
      closeOnOverlayClick={false}
      classNames={{ modal: "custom-modal1" }}
    >
      <div
        style={{
          backgroundColor: "white",
          borderRadius: "10px",
          maxWidth: "800px",
          width: "100%",
          margin: "auto",
          paddingRight: 30,
          paddingLeft: 30,
          paddingBottom: 20,
          paddingTop: 20,
          position: "relative",
        }}
      >
        <h1
          style={{
            textAlign: "center",
            fontSize: 34,
            fontWeight: "700",
            color: "#1A202C",
          }}
        >
          Assets Assign
        </h1>
        <h4
          style={{
            marginTop: 10,
            marginBottom: 20,
            textAlign: "center",
            fontWeight: "400",
            color: "#6C757D",
          }}
        >
          Please fill in the necessary details
        </h4>

        <form onSubmit={handleSubmit} className="form-gridAsset">
          <div className="form-groupAsset">
            <label htmlFor="itemname">Item Name:</label>
            <input
              type="text"
              name="itemname"
              id="itemname"
              placeholder="Enter item Categories"
              value={assetsData?.itemname}
              readOnly
            />
          </div>
          <div className="form-groupAsset">
            <label htmlFor="category">Employee Name:</label>
            <select
              name="name"
              id="name"
              value={formData.name}
              onChange={handleChange}
              required
            >
              <option value="">Select emp name</option>
              {getEmployeeDetails?.map((employee, index) => (
                <option key={index} value={employee?.id}>
                  {employee.name}
                </option>
              ))}
            </select>
          </div>
          <div className="form-groupAsset">
            <label htmlFor="categories">Categories:</label>
            <input
              type="text"
              name="categories"
              id="categories"
              placeholder="Enter item Categories"
              value={assetsData?.category}
              readOnly
            />
          </div>
          <div className="form-groupAsset">
            <label htmlFor="model">Model/Brand:</label>
            <input
              type="text"
              name="model"
              id="model"
              placeholder="Enter modal or brand"
              value={assetsData?.model_brand}
              readOnly
            />
          </div>
          <div className="form-groupAsset">
            <label htmlFor="model_number">Model Number:</label>
            <input
              type="text"
              name="model_number"
              id="model_number"
              placeholder="Enter modal number"
              value={assetsData?.model_number}
              readOnly
            />
          </div>
          <div className="form-groupAsset">
            <label htmlFor="serial_number">Serial Number:</label>
            <input
              type="text"
              name="serial_number"
              id="serial_number"
              placeholder="Enter serial number"
              value={assetsData?.serial_number}
              readOnly
            />
          </div>
          <div className="form-groupAsset">
            <label htmlFor="accessories">Assigned By:</label>
            <input
              type="text"
              name="accessories"
              id="accessories"
              placeholder="Enter who assign"
              value={profileData?.name}
              readOnly
            />
          </div>
          <div className="form-groupAsset">
            <label htmlFor="item_remark">Item remark:</label>
            <input
              type="text"
              name="item_remark"
              id="item_remark"
              placeholder="Remark assign item"
              value={assetsData?.description}
              readOnly
            />
          </div>

          <div className="form-groupAsset">
            <label htmlFor="assigned_date">Assigned Date:</label>
            <input
              type="date"
              name="assigned_date"
              id="assigned_date"
              value={formData.assigned_date}
              placeholder="Select date"
              onChange={handleChange}
              required
            />
          </div>
          <div className="form-groupAsset">
            <label htmlFor="image">Select image item:</label>
            <div
              style={{
                flexDirection: "row",
                display: "flex",
                alignItems: "center",
              }}
            >
              <input
                type="file"
                multiple
                onChange={handleImageChange}
                accept="image/*"
                required
              />

              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  marginLeft: -30,
                }}
              ></div>
            </div>
          </div>
          <div
            style={{
              gap: 10,
              width: "100%",
              alignItems: "center",
              justifyContent: "center",
              display: "flex",
              alignSelf: "center",
            }}
          >
            <div>
              <div
                style={{
                  display: "flex",
                  gap: "10px",
                  alignItems: "center",
                  justifyContent: "center",
                  alignSelf: "center",
                  marginLeft: 200,
                }}
              >
                {selectedImages.map((image, index) => (
                  <img
                    key={index}
                    src={URL.createObjectURL(image)}
                    alt={`preview-${index}`}
                    style={{
                      width: "50px",
                      height: "50px",
                      objectFit: "cover",
                    }}
                  />
                ))}
              </div>
            </div>
          </div>
          <div className="form-groupAsset1">
            <label
              htmlFor="description1"
              style={{
                fontSize: "18px",
                fontWeight: "500",
                color: "black",
              }}
            >
              Description:
            </label>
            <textarea
              name="description1"
              id="description1"
              placeholder="Enter description"
              value={formData.description1}
              onChange={handleChange}
              required
              rows="1"
            />
          </div>

          <div
            style={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "flex-end",
              width: "100%",
              alignItems: "center",
            }}
          >
            <div
              style={{
                width: 100,
                height: 40,

                justifyContent: "center",
                display: "flex",
                alignItems: "center",

                borderRadius: 5,
                color: "#047EFF",
                fontSize: 16,
                fontWeight: "700",
              }}
            >

              <h2 style={{ fontSize: 18 }} onClick={() => {
                onClose();
                setFormData(initialFormData);
                setSelectedImages([]);
              }}>Cancel</h2>
            </div>

            <div
              style={{
                width: 100,
                height: 40,
                background: "#047EFF",
                justifyContent: "center",
                display: "flex",
                alignItems: "center",

                borderRadius: 5,
                color: "white",
                fontSize: 16,
                fontWeight: "700",
              }}
            >
              <button type="submit">Create</button>
            </div>
          </div>
        </form>
      </div>
    </Modal>
  );
};

export default AssetAssign;
